<p class="text-xs text-slate-500 px-1 pb-3">
  Listado de instructivos disponible, de libre acceso y con registro de
  avances.
</p>

<div
  class="w-full p-1 gap-4 flex flex-col items-center"
>
  @for (instructivo of instructivos; track $index) {
    <div
      class="w-full rounded-lg shadow-md cursor-pointer bg-white transition-all duration-200 hover:shadow-lg flex flex-col overflow-hidden"
      (click)="abrir(instructivo)"
    >
      <div class="w-full aspect-video relative">
        <picture>
          <img
            [src]="instructivo.thumbnail + '-1.jpg'"
            alt=""
            class="absolute inset-0 h-full w-full object-cover object-top"
            #img1
            (error)="img1.classList.add('hidden')"
          />
          <img
            [src]="instructivo.thumbnail + '-01.jpg'"
            alt=""
            class="absolute inset-0 h-full w-full object-cover object-top"
            #img2
            (error)="img2.classList.add('hidden')"
          />
          <img
            [src]="instructivo.thumbnail + '-001.jpg'"
            alt=""
            class="absolute inset-0 h-full w-full object-cover object-top"
            #img3
            (error)="img3.classList.add('hidden')"
          />
        </picture>
      </div>
      <div class="p-2">
        <p class="text-sm text-slate-700 leading-snug line-clamp-3">
          {{ instructivo.nombre }}
        </p>
      </div>

      <div class="h-2 bg-gray-200 rounded-b-lg">
        <div
          class="h-2 bg-blue-600 rounded-b-lg transition-all duration-200"
          [style.width.%]="
            instructivo.instructivoUsuarios.length > 0
              ? instructivo.instructivoUsuarios[0].percent
              : 0
          "
        ></div>
      </div>
    </div>
  } @empty {
    <p class="text-center">Nada que mostrar</p>
  }
</div>
